module.exports = __webpack_public_path__ + "img/firma-henry-dunant.04ec6ea5.png";